import { makeAutoObservable } from 'mobx';
import { MessageModalTypes } from '~/definitions/messageModal';

export default class MessageModalStore {
    type: MessageModalTypes = 'warning';
    isOpen: boolean = false;
    message: string | JSX.Element = '';

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.type = 'warning';
        this.isOpen = false;
        this.message = '';
    }

    setType = (ty: MessageModalTypes) => {
        this.type = ty;
    };

    setIsOpen = (isOp: boolean) => {
        this.isOpen = isOp;
    };

    setMessage = (msg: string | JSX.Element) => {
        this.message = msg;
    };
}
